import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Text, ResponsiveContainer
} from 'recharts';

export default class BasicChart extends React.Component {
  render() {
    const { data } = this.props
    return (
      <ResponsiveContainer>
        <LineChart
          width={600}
          height={400}
          data={data}
          margin={{
            top: 5, right: 30, left: 20, bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="6 6" />
          <XAxis
            dataKey="date"
          />
          <YAxis />
          <Tooltip formatter={(value) => new Intl.NumberFormat('en-US', { style: "currency", currency: "USD", currencyDisplay: "narrowSymbol" }).format(value)} />
          <Line type="monotone" dataKey="price" stroke="#f58800" activeDot={{ r: 8 }} />
        </LineChart>
      </ResponsiveContainer>
    )
  }
}